module.exports = __webpack_public_path__ + "static/media/diagnosis_form.bd21faf9.svg";